module.exports = __webpack_public_path__ + "media/images/solution-link-qr-fa7bf1ebbe547aba632cbdf805c631b9.png";